import { Vector } from './vector';

export class Size {
  constructor(readonly width: number, readonly height: number = width) {}

  vector() {
    return new Vector(this.width, this.height)
  }
}
